<template>
  <Modal
    :is-open="isOpen"
    class="reject-modal"
    data-testid="reject-modal"
    title="Recusar sugestão"
    @close="emitClose"
  >
    <BaseText>
      Essa sugestão será descartada e nenhuma mudança sugerida será aplicada.
    </BaseText>
    <template #buttonContainer>
      <ButtonContainer>
        <template #button-primary>
          <ButtonPrimary label="Recusar sugestão" @click="emitRejected" />
        </template>
        <template #button-secondary>
          <ButtonSecondary label="Voltar" @click="emitClose" />
        </template>
      </ButtonContainer>
    </template>
  </Modal>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  Modal,
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import * as trackEvents from '@/modules/wealth/views/InvestmentSuggestions/track-events';

@Component({
  components: {
    Modal,
    BaseText,
    ButtonContainer,
    ButtonPrimary,
    ButtonSecondary
  }
})
export default class RejectModal extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isOpen!: boolean;

  @Watch('isOpen', { immediate: true })
  public async trackRefusalLoad(isOpen: boolean) {
    if (isOpen) {
      trackEvents.trackSuggestionRefusalLoad();
    }
  }

  @Emit('close')
  emitClose() {
    trackEvents.trackCancelSuggestionRefusal();
  }

  @Emit('rejected')
  emitRejected() {
    trackEvents.trackConfirmSuggestionRefusal();
  }
}
</script>

<style lang="less" scoped>
.reject-modal {
  /deep/.base-modal--wrapper {
    max-width: 592px;
  }
}
</style>
